import React, { useState } from "react";
import "../styles/PlatformsPage.css";

import academylogo from '../assets/academylogo.png';
import storelogo from '../assets/storelogo.png';
import clublogo from '../assets/clublogo.png';
import forumlogo from '../assets/forumlogo.png';

// Platform illustrations
import adamacademy from "../assets/platforms/adamacademy.jpg";
import adamclub from "../assets/platforms/adamclub.png";
import adamforum from "../assets/platforms/adamforum.jpg";
import adamstore from "../assets/platforms/adamstore.jpg";

// Geliştirme aşaması modalı
const DevelopmentModal = ({ platform, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="platforms-modal-overlay" onClick={onClose}>
      <div className="platforms-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="platforms-modal-close" onClick={onClose}>×</button>
        
        <div className="platforms-modal-header" style={{ backgroundColor: platform.color }}>
          <img src={platform.logo} alt={platform.name} className="platforms-modal-logo" />
          <h2 className="platforms-modal-title">{platform.name}</h2>
        </div>
        
        <div className="platforms-modal-body">
          <div className="platforms-modal-badge">
            <span className="platforms-modal-status platforms-modal-status--development">
              🚧 Under Development
            </span>
          </div>
          
          <p className="platforms-modal-message">
            We're working hard to bring you an amazing experience! 
            <strong> {platform.name}</strong> is currently in development and will be launching soon.
          </p>
          
          <div className="platforms-modal-features">
            <h3>Coming Features:</h3>
            <ul>
              {platform.features.map((feature, index) => (
                <li key={index}>✨ {feature}</li>
              ))}
            </ul>
          </div>
          
          <div className="platforms-modal-actions">
            <button 
              className="platforms-modal-button platforms-modal-button--notify"
              onClick={() => {
                alert(`You'll be notified when ${platform.name} launches!`);
                onClose();
              }}
            >
              🔔 Notify Me When Live
            </button>
            <button 
              className="platforms-modal-button platforms-modal-button--explore"
              onClick={onClose}
            >
              Explore Other Platforms
            </button>
          </div>
        </div>
        
        <div className="platforms-modal-footer">
          <p className="platforms-modal-note">
            * Stay tuned for updates on our development progress!
          </p>
        </div>
      </div>
    </div>
  );
};

const platformsData = [
  {
    id: "store",
    name: "ADAM STORE",
    shortDescription: "Establish B2B business connections, expand your company's network.",
    longDescription: "Adam Store is a marketplace specifically designed for businesses. Companies can promote their products and services, find new business partners, and increase their sales. Connect with verified suppliers and buyers worldwide.",
    logo: storelogo,
    illustration: adamstore,
    link: "", // Boş, geliştirme aşamasında
    externalLink: false,
    features: ["Global B2B Marketplace", "Verified Suppliers", "Secure Transactions", "Business Networking"],
    color: "#00578e",
    status: "development",
    progress: 75
  },
  {
    id: "academy",
    name: "ADAM INTERNATIONAL ACADEMY",
    shortDescription: "Enhance your professional skills with an online education platform.",
    longDescription: "Adam international Academy offers comprehensive training solutions for employees and businesses with courses provided by expert instructors in their respective fields. Advance your career with industry-recognized certifications.",
    logo: academylogo,
    illustration: adamacademy,
    link: "https://adaminternationalacademy.com/",
    externalLink: true,
    features: ["Professional Certifications", "Expert-Led Courses", "Flexible Learning", "Corporate Training"],
    color: "#2c89a0",
    status: "live",
    progress: 100
  },
  {
    id: "forum",
    name: "ADAM FORUM",
    shortDescription: "Share knowledge with industry experts on ADAM GLOBAL BUSINESS FORUM.",
    longDescription: "Adam Forum enables professionals in the business world to come together, exchange ideas, and share up-to-date industry information. Join discussions, attend webinars, and network with thought leaders.",
    logo: forumlogo,
    illustration: adamforum,
    link: "", // Boş, geliştirme aşamasında
    externalLink: false,
    features: ["Industry Discussions", "Expert Webinars", "Knowledge Sharing", "Professional Networking"],
    color: "#003f6b",
    status: "development",
    progress: 5
  },
  {
    id: "club",
    name: "ADAM CLUB",
    shortDescription: "Engage with exclusive communities on ADAM INTERNATIONAL BUSINESS CLUB.",
    longDescription: "Adam Club is an exclusive club that helps professionals with similar interests in the business world come together and expand their networks. Access premium events and strategic partnerships.",
    logo: clublogo,
    illustration: adamclub,
    link: "", // Boş, geliştirme aşamasında
    externalLink: false,
    features: ["Exclusive Membership", "Premium Events", "Strategic Partnerships", "Private Networking"],
    color: "#00a8cc",
    status: "development",
    progress: 10
  }
];

const PlatformsPage = () => {
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePlatformClick = (platform, e) => {
    e.preventDefault();
    
    // Adam international Academy için direkt linke yönlendir
    if (platform.externalLink && platform.link) {
      window.open(platform.link, '_blank');
    } 
    // Diğer platformlar için modal aç
    else {
      setSelectedPlatform(platform);
      setIsModalOpen(true);
      document.body.style.overflow = 'hidden';
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPlatform(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="platforms-page">
      {/* Hero Section */}
      <header className="platforms-hero">
        <div className="platforms-hero-content">
          <h1 className="platforms-hero-title">Adam Platforms</h1>
          <p className="platforms-hero-subtitle">
            The integrated ecosystem of platforms designed to accelerate your business growth and professional development.
          </p>
        </div>
      </header>

      {/* Introduction Section */}
      <section className="platforms-intro">
        <div className="platforms-intro-content">
          <h2 className="platforms-section-title">Our Integrated Ecosystem</h2>
          <p className="platforms-section-subtitle">
            Four powerful platforms working together to provide comprehensive solutions for businesses and professionals worldwide.
          </p>
        </div>
      </section>

      {/* Platforms Overview Cards */}
      <section className="platforms-overview">
        <div className="platforms-cards-grid">
          {platformsData.map((platform, index) => (
            <div key={platform.id} className="platform-card">
              <div className="platform-card-header" style={{ backgroundColor: platform.color }}>
                <img src={platform.logo} alt={platform.name} className="platform-card-logo" />
                {platform.status === 'development' && (
                  <span className="platform-card-badge platform-card-badge--development">🚧 Dev</span>
                )}
              </div>
              <div className="platform-card-content">
                <h3 className="platform-card-title">{platform.name}</h3>
                <p className="platform-card-description">{platform.shortDescription}</p>
                
                {platform.status === 'development' && (
                  <div className="platform-card-progress">
                    <div className="platform-card-progress-header">
                      <span>Progress</span>
                      <span>{platform.progress}%</span>
                    </div>
                    <div className="platform-card-progress-bar">
                      <div 
                        className="platform-card-progress-fill" 
                        style={{ width: `${platform.progress}%`, backgroundColor: platform.color }}
                      ></div>
                    </div>
                  </div>
                )}
                
                <div className="platform-card-features">
                  {platform.features.slice(0, 2).map((feature, idx) => (
                    <span key={idx} className="platform-card-feature">
                      {feature}
                    </span>
                  ))}
                  {platform.features.length > 2 && (
                    <span className="platform-card-feature-more">+{platform.features.length - 2}</span>
                  )}
                </div>
                
                <button 
                  onClick={(e) => handlePlatformClick(platform, e)}
                  className={`platform-card-button ${
                    platform.status === 'live' ? 'platform-card-button--live' : 'platform-card-button--development'
                  }`}
                >
                  {platform.status === 'live' ? 'Visit Platform' : 'View Details'}
                  <span className="platform-card-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Platform Details Sections */}
      <section className="platforms-details">
        {platformsData.map((platform, index) => (
          <div key={platform.id} className="platform-detail-section">
            <div className={`platform-detail-container ${index % 2 === 0 ? 'platform-detail-left' : 'platform-detail-right'}`}>
              <div className="platform-detail-content">
                <div className="platform-detail-header">
                  <img src={platform.logo} alt={platform.name} className="platform-detail-logo" />
                  <div className="platform-detail-title">
                    <h2>{platform.name}</h2>
                    <div className="platform-detail-line" style={{ backgroundColor: platform.color }}></div>
                  </div>
                </div>
                <p className="platform-detail-description">{platform.longDescription}</p>
                <div className="platform-detail-features">
                  <h4>Key Features:</h4>
                  <ul>
                    {platform.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <button 
                  onClick={(e) => handlePlatformClick(platform, e)}
                  className={`platform-detail-button ${
                    platform.status === 'live' ? 'platform-detail-button--live' : 'platform-detail-button--development'
                  }`}
                >
                  {platform.status === 'live' ? `Visit ${platform.name}` : 'Coming Soon'}
                </button>
              </div>
              <div className="platform-detail-visual">
                <img src={platform.illustration} alt={platform.name} className="platform-detail-illustration" />
                
                {/* OVERLAY RENGİ NASIL AYARLANIR - AÇIKLAMA */}
                {/* 
                  platform.color + '20' = rengin %20 opaklıkta versiyonu
                  Örnek: 
                  - '#00578e' + '20' = '#00578e20' (Store için)
                  - '#2c89a0' + '20' = '#2c89a020' (Academy için)
                  - '#003f6b' + '20' = '#003f6b20' (Forum için)
                  - '#00a8cc' + '20' = '#00a8cc20' (Club için)
                  
                  Opaklık değerleri:
                  - '10' = %10 opaklık
                  - '20' = %20 opaklık
                  - '30' = %30 opaklık
                  - '40' = %40 opaklık
                  - '50' = %50 opaklık
                  - '60' = %60 opaklık
                  - '70' = %70 opaklık
                  - '80' = %80 opaklık
                  - '90' = %90 opaklık
                  - 'ff' = %100 opaklık
                */}
                <div 
                  className="platform-detail-overlay" 
                  style={{ 
                    backgroundColor: platform.color + '20', // %20 opaklıkta renk
                    backdropFilter: 'blur(5px)' // İsteğe bağlı blur efekti
                  }}
                >
                  <h3 style={{ color: platform.color }}>
                    {platform.status === 'live' ? '🎓 Now Live!' : '🚧 Coming Soon'}
                  </h3>
                  <p>
                    {platform.status === 'live' 
                      ? 'Join thousands of learners today' 
                      : `Launching with ${platform.progress}% complete`}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* CTA Section */}
      <section className="platforms-cta">
        <div className="platforms-cta-content">
          <h2 className="platforms-cta-title">Ready to Transform Your Business?</h2>
          <p className="platforms-cta-text">
            Join our integrated platforms and unlock new opportunities for growth, learning, and networking.
          </p>
          <div className="platforms-cta-buttons">
            <a href="/contact" className="platforms-cta-button platforms-cta-button--primary">
              Get Started Today
            </a>
            <a href="/sectors" className="platforms-cta-button platforms-cta-button--secondary">
              Explore Our Sectors
            </a>
          </div>
        </div>
      </section>

      {/* Development Modal */}
      {selectedPlatform && (
        <DevelopmentModal
          platform={selectedPlatform}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default PlatformsPage;